import React from 'react';
import { BaristaOrder, OrderStatus } from './baristaData';
import BaristaOrderCard from './BaristaOrderCard';
import Icon from '@/components/ui/AppIcon';

interface OrderColumnProps {
  title: string;
  status: OrderStatus;
  orders: BaristaOrder[];
  count: number;
  color: string;
  dotColor: string;
  onAdvance: (id: string) => void;
  onComplete: (id: string) => void;
  onSelect: (order: BaristaOrder) => void;
}

export default function OrderColumn({
  title, status, orders, count, color, dotColor, onAdvance, onComplete, onSelect
}: OrderColumnProps) {
  return (
    <div className="w-72 flex flex-col">
      {/* Column header */}
      <div className="flex items-center gap-2 mb-3 px-1">
        <span className={`w-2 h-2 rounded-full ${dotColor}`} />
        <h2 className={`font-bold text-sm ${color}`}>{title}</h2>
        <span className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full bg-white/10 ${color}`}>
          {count}
        </span>
      </div>

      {/* Cards */}
      <div className="space-y-3 flex-1">
        {orders.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 text-center border-2 border-dashed border-white/10 rounded-2xl">
            <Icon name="ClipboardDocumentListIcon" size={28} className="text-white/20 mb-2" />
            <p className="text-white/30 text-xs font-medium">Sipariş yok</p>
          </div>
        ) : (
          orders.map((order) => (
            <BaristaOrderCard
              key={order.id}
              order={order}
              onAdvance={onAdvance}
              onComplete={onComplete}
              onSelect={onSelect}
            />
          ))
        )}
      </div>
    </div>
  );
}